module.exports = __webpack_public_path__ + "3b08fd8337df2703b75ead7cf5734afb.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-service-img1.jpg
// module id = 242
// module chunks = 2